/***
 *
 *   SIGN UP (user)
 *   Signup form for child users.
 *
 **********/

import { useContext } from "react";
import {
  AuthContext,
  Form,
  Link,
  SocialSignin,
  Separator,
  useSearchParams,
} from "components/lib";

export function SignupUser({ t }) {
  // contet
  const authContext = useContext(AuthContext);

  // state
  const [searchParams] = useSearchParams();

  return (
    <div>
      <div className="text-center space-y-2">
        <h1 className="text-2xl sm:text-3xl font-light text-white fade-in tracking-wide">
          {t("auth.signup.user.title")}
        </h1>
        <p className="text-white/60 text-sm font-light slide-up" style={{animationDelay: '0.1s'}}>
          Create your account to access analytics dashboard
        </p>
      </div>

      <div className="mt-8"></div>

      {/* <SocialSignin
        network={["facebook", "twitter"]}
        invite={searchParams.get("id")}
      /> */}
      {/* <Separator label={t("global.social.or")} /> */}

      <Form
        inputs={{
          name: {
            label: t("auth.signup.user.form.name.label"),
            value: "",
            type: "text",
            required: true,
            errorMessage: t("auth.signup.user.form.name.error"),
          },
          email: {
            label: t("auth.signup.user.form.email.label"),
            value: searchParams.get("email"),
            type: "email",
            required: true,
          },
          password: {
            label: t("auth.signup.user.form.password.label"),
            type: "password",
            required: true,
            validation: { complex: true },
          },
          terms: {
            label: (
              <>
                {t("auth.signup.account.form.terms.text")}{" "}
                <Link
                  url="/terms"
                  text={t("auth.signup.account.form.terms.terms_of_use")}
                  className="text-white/60 hover:text-white/90 text-xs font-light tracking-wide transition-colors duration-200 hover:underline"
                />{" "}
                &{" "}
                <Link
                  url="/privacy"
                  text={t("auth.signup.account.form.terms.privacy_policy")}
                  className="text-white/60 hover:text-white/90 text-xs font-light tracking-wide transition-colors duration-200 hover:underline"
                />
                .
              </>
            ),
            type: "checkbox",
            required: true,
            errorMessage:
              "You must agree to the terms and conditions to proceed.",
          },
          confirm_password: {
            type: "hidden",
            value: null,
          },
          invite_id: {
            type: "hidden",
            value: searchParams.get("id"),
          },
        }}
        url="/api/user"
        method="POST"
        redirect="/dashboard"
        buttonText={t("auth.signup.user.form.button")}
        callback={authContext.signin}
      />

      <footer className="justify-center text-xs space-x-2 slide-up font-light" style={{animationDelay: '0.5s'}}>
        <span className="text-white/50">{t("auth.signup.user.footer.text")}</span>
        <Link 
          url="/signin" 
          text={t("auth.signup.user.footer.link_text")} 
          className="text-white/80 hover:text-white tracking-wide transition-colors duration-200 hover:underline"
        />
      </footer>
    </div>
  );
}
